module.exports = __webpack_public_path__ + "media/images/icons/add-circle-b8fd521e41b364e48b77ed1324065a44.svg";